import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";


//Sentry.init({dsn: "https://4fd0806eb82b44d4a007148172dcce96@o1018942.ingest.sentry.io/4504960911933440",});

// const root = ReactDOM.render(
//   document.getElementById('root') as HTMLElement
// );

/* ReactDOM.render(
 *     <React.StrictMode>
 *       <App />
 *     </React.StrictMode>,
 *     document.getElementById('root')
 * );
 * 
 *  */
ReactDOM.render(
      <App />,
      document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
